import React from "react";

export default function LoadingSpinner() {
  return (
    <div className="gc__loading_spinner_div">
      <div className="gc__loading_spinner"><p></p></div>
    </div>
  )
}
